import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";

import { SWFBlurb } from "../components/SWFBlurb";
import { useLoggedOutBrandNodes } from "../hooks/useLoggedOutBrandNodes";

interface IProps {
  issueL3: string | undefined;
  loggedOutExperience: boolean;
}

export const Blurb: React.FC<IProps> = ({ issueL3, loggedOutExperience }) => {
  const brandNodes = useLoggedOutBrandNodes();
  if (issueL3 === brandNodes.L3.Availability && !loggedOutExperience) {
    return (
      <>
        <SWFBlurb />
        <Spacer height="2x" />
      </>
    );
  }

  return null;
};
